import { useEffect, useState } from 'react';
import { getGoalAttainment } from '../services';
import { IGoalAttainmentItem, IGoalAttainmentTeamTotal, HookState } from '../types';

export interface GoalAttainmentState extends HookState<IGoalAttainmentItem[]> {
	teamTotals: IGoalAttainmentTeamTotal[] | null;
}

export function useGoalAttainment(options?: { team?: string }): GoalAttainmentState {
	const [state, setState] = useState<GoalAttainmentState>({
		data: null,
		teamTotals: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	const team = options?.team;

	useEffect(() => {
		let cancelled = false;
		const controller = new AbortController();
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getGoalAttainment({ team })
			.then(({ data, teamTotals, cachedAt }) => {
				if (!cancelled) setState({ data, teamTotals, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled && !controller.signal.aborted)
					setState({ data: null, teamTotals: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, [team]);

	return state;
}

function resolveErrorMessage(err: unknown): string {
	if (err instanceof Error) return err.message;
	return 'Error al cargar los datos';
}
